import React, { useState } from 'react';
import { PlayerProfileCard } from './PlayerProfileCard';
import { HeadToHeadPanel } from './HeadToHeadPanel';
import { type Fixture } from '../../services/TennisLiveApi';
import giroImage from '../../assets/tile_tennis_v2_resultados.png';
import './Giro.css';

interface GiroSectionProps {
  fixture: Fixture;
}

export const GiroSection: React.FC<GiroSectionProps> = ({ fixture }) => {
  const [selectedPlayer, setSelectedPlayer] = useState<{ id: number, name: string } | null>(null);

  if (!fixture || !fixture.homePlayer || !fixture.awayPlayer) {
    return null;
  }

  const p1 = fixture.homePlayer;
  const p2 = fixture.awayPlayer;

  const currentPlayer = selectedPlayer || { id: p1.id, name: p1.name };

  return (
    <div className="gr-section">
      <div className="gr-section-header">
        <img src={giroImage} alt="Giro de Torneios Profissionais" className="gr-header-image" />
      </div>
      <div className="gr-section-content">
        <div className="gr-left-column">
          <PlayerProfileCard playerId={currentPlayer.id} playerName={currentPlayer.name} />
        </div>
        <div className="gr-right-column">
          <HeadToHeadPanel 
            player1Id={p1.id} 
            player2Id={p2.id} 
            player1Name={p1.name} 
            player2Name={p2.name} 
            onPlayerClick={(id, name) => setSelectedPlayer({ id, name })}
          />
        </div>
      </div>
    </div>
  );
};
